<template>
<div class="chapter">
<div class="inner_page">
<p class="GillSans-Bold" style="text-align:center">Other Close to Home Books<br/>
By John McPherson</p>
<p class="GillSans" style="text-align:center">Close to Home<br/>
One Step Closer to Home<br/>
Dangerously Close to Home<br/>
Home: The Final Frontier<br/>
The Honeymoon Is Over<br/>
The Silence of the Lamberts<br/>
Striking Close to Home<br/>
The Close to Home Survival Guide<br/>
Close to Home Uncut<br/>
</p>
<p class="GillSans" style="text-align:center"><span class="GillSans-Bold">Treasury Collections</span>
<br/>
Close to Home Revisited<br/> Close to Home Unplugged</p>
<p class="GillSans"> </p>
<p class="GillSans" style="text-align:center"><span class="GillSans-Bold">Also from John McPherson</span><span class="GillSans" style="text-align:center"><br/>High School Isn’t Pretty</span><br/>
Close to Home: A Book of Postcards<br/>
The Barber of Bingo<br/>
The Get Well Book<br/>
Give Mommy the Superglue and Other Tips on Surviving Parenthood</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// VCS_03.vue?9c1cf950